<template>
  <div class="col-10 offset-1">
    <div class="hospital-card row">
      <div class="col-8 offset-2 col-md-3 offset-md-0">
        <img v-if="hospital.logo.large" class="logo" :src="hospital.logo.large" :alt="hospital.name">
        <img v-else class="logo" src="@/assets/donation-info/donation-thank-you.png" alt="hospital logo">
      </div>
      <div class="col-12 col-md-9 info">
        <h2>{{ hospital.name }}</h2>
        <h3>{{ hospital.location }}</h3>
        <table v-if="showAddress">
          <tr>
            <td class="text-nowrap">ที่อยู่</td>
            <td>{{ hospital.address }}</td>
          </tr>
          <tr>
            <td class="text-nowrap">อีเมล์</td>
            <td>{{ hospital.email }}</td>
          </tr>
          <tr>
            <td class="text-nowrap">เว็บไซต์</td>
            <td>
              <a :href="hospital.website" target="_blank">{{ hospital.name }}</a>
            </td>
          </tr>
          <tr>
            <td class="text-nowrap">โทรศัพท์</td>
            <td>{{ hospital.phone }}</td>
          </tr>
        </table>
        <span v-else @click="toggleAddress()">Show address...</span>
      </div>
      <spinning-loader class="spin-loader" size="80" v-if="showSpinner"/>
      <div class="col-12" v-else>
        <div class="blood-bag-row" v-for="(bag, index) in bloodBags" :key="index">
          <hr/>
          <div class="blood-type">
            <img :src="getBloodBagImg(bag.bloodBagColor)" alt="blood-bag">
            <div class="detail">
              <div class="pet">
                <span class="title">Pet Type</span><br/><span>{{ bag.petType }}</span>
              </div>
              <div class="type">
                <span class="title">Product Type</span><br/><span>{{ bag.productType }}</span>
              </div>
              <div class="group">
                <span class="title">Blood Group</span><br/><span v-html="bag.bloodGroup"></span>
              </div>
              <div class="group">
                <span class="title">Total Volume</span><br/><span v-html="bag.vol + 'ml'"></span>
              </div>
              <div class="bag">
                <span class="title">Bags</span><br/><span v-html="bag.bloodBagCount"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpinningLoader from '@/components/SpinningLoader.vue'
import pinkBag from '@/assets/blood-bag/pink-bag.png'
import redBag from '@/assets/blood-bag/red-bag.png'

export default {
  name: 'HospitalCard',
  props: {
    hospital: Object,
    showBloodBag: Boolean,
    petTypeFilter: ''
  },
  data () {
    return {
      bloodBags: {},
      showSpinner: this.showBloodBag,
      showAddress: true
    }
  },
  mounted () {
    if (window.innerWidth < 500) {
      this.showAddress = false
    }
    this.renderBloodBags()
  },
  watch: {
    petTypeFilter: function (val) {
      this.renderBloodBags()
    }
  },
  methods: {
    getBloodBagImg: function (color) {
      if (color === 'pink') {
        return pinkBag
      } else if (color === 'red') {
        return redBag
      } else {
        return pinkBag
      }
    },
    toggleAddress: function () {
      this.showAddress = !this.showAddress
    },
    renderBloodBags: function () {
      if (this.showBloodBag) {
        var validBloodCollection = this.$store.getters.getValidBloodCollection
        if (validBloodCollection.length === 0) {
          this.$store.dispatch('getBloodCollectionData').then(() => {
            this.updateBloodBag()
          })
        } else {
          this.updateBloodBag()
        }
      }
    },
    updateBloodBag: function () {
      var bloodBags = {}
      for (var bloodBag of this.$store.getters.getValidBloodCollection) {
        if (this.petTypeFilter !== '' && this.petTypeFilter !== bloodBag.pet_type) {
          continue
        }

        if (bloodBag.pet_type && bloodBag.hospital === this.hospital.id) {
          if (!bloodBag.blood_group) {
            bloodBag.blood_group = ''
          }
          var type = bloodBag.pet_type + bloodBag.blood_type + bloodBag.blood_group
          if (type in bloodBags) {
            var vol = bloodBags[type].vol + parseInt(bloodBag.collected_quantity)
            var bloodBagCount = bloodBags[type].bloodBagCount + 1
            bloodBags[type] = {
              bloodBagColor: 'red',
              petType: bloodBag.pet_type,
              productType: bloodBag.blood_type,
              bloodGroup: bloodBag.blood_group || 'unknown',
              vol: vol,
              bloodBagCount: bloodBagCount
            }
          } else {
            bloodBags[type] = {
              bloodBagColor: 'red',
              petType: bloodBag.pet_type,
              productType: bloodBag.blood_type,
              bloodGroup: bloodBag.blood_group || 'unknown',
              vol: parseInt(bloodBag.collected_quantity),
              bloodBagCount: 1
            }
          }
        }
      }
      this.showSpinner = false
      this.bloodBags = bloodBags

      if (Object.keys(this.bloodBags).length === 0) {
        this.$emit('emptyBloodBags', this.hospital)
      }
    }
  },
  components: {
    SpinningLoader
  }
}
</script>

<style scoped lang="scss">
.hospital-card {
  padding: 0rem 0rem 1rem;
  background-color: white;
  border-radius: $border-radius-xl;
  box-shadow: $box-shadow-lg;
  margin-bottom: 1rem;
  .logo {
    margin-top: 1rem;
    width: 100%;
    height: 8rem;
    object-fit: contain;
  }
  .info {
    margin-top: 1rem;
    margin-bottom: 0rem;
    font-weight: $font-weight-light;
    font-family: $font-family-thai;
    h2 {
      font-size: $h5-font-size;
      font-weight: $font-weight-light;
    }
    h3 {
      font-size: $h5-font-size;
      font-weight: $font-weight-light;
    }
    table {
      font-size: $font-size-sm;
      td {
        vertical-align: top;
      }
    }
    span {
      color: $primary;
      cursor: pointer;
    }
  }
  .blood-bag-row {
    hr {
      margin: 0.5rem 0;
    }
    .blood-type {
      text-align: center;
      img {
        display: inline-block;
        margin-right: 0;
        width: 2.5rem;
        vertical-align: top;
      }
      .detail {
        display: inline-block;
        margin: 0 1rem;
        font-size: $h6-font-size;
        text-align: left;
        .title {
          font-size: $font-size-sm;
          color: $gray-500;
          font-weight: $font-weight-light;
        }
        .pet {
          width: 6rem;
        }
        .type {
          width: 7rem;
        }
        .group {
          width: 6rem;
        }
        .bag {
          width: 2rem;
        }
      }
    }
  }
}
.spin-loader {
  margin: 1rem auto 0;
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .hospital-card {
    padding: 1rem;
    .logo {
      height: 10rem;
    }
    .info {
      margin-bottom: 1rem;
      h2 {
        font-size: $h3-font-size;
      }
      h3 {
        font-size: $h3-font-size;
      }
      table {
        font-size: $font-size-base;
      }
    }
    .blood-bag-row {
      .blood-type {
        img {
          margin-right: 1rem;
        }
        .detail {
          display: inline-block;
          font-size: $h5-font-size;
          div {
            display: inline-block;
            margin: 0 1.5rem;
          }
          .type {
            width: 10rem;
          }
        }
      }
    }
  }
  .spin-loader {
    margin: auto;
  }
}
</style>
